// Totals the data-transfer lines of a usage report, per direction, per unit.
//
// The classification itself is not done here: a row arrives carrying `direction`
// ("inbound" / "outbound", empty on everything else), decided once on the backend by
// models.TransferDirection from the SKU's name. It used to be a second regex match in
// this file, which meant two implementations of one heuristic that could disagree
// about the same row — the console now reads the answer rather than re-deriving it.
//
// Quantities are kept per unit rather than summed: GB added to TB is a number in
// neither, and the provider does not report one unit for every SKU.
export function bandwidthSummary(rows) {
  const totals = { inbound: new Map(), outbound: new Map() };
  const lines = { inbound: 0, outbound: 0 };
  for (const row of rows) {
    const direction = row.direction;
    if (direction !== 'inbound' && direction !== 'outbound') continue;
    const unit = row.unit || '';
    totals[direction].set(unit, (totals[direction].get(unit) || 0) + (row.quantity || 0));
    lines[direction] += 1;
  }
  const perUnit = (map) =>
    [...map.entries()]
      .map(([unit, quantity]) => ({ unit, quantity }))
      .sort((a, b) => b.quantity - a.quantity);
  return {
    inbound: perUnit(totals.inbound),
    outbound: perUnit(totals.outbound),
    inboundLines: lines.inbound,
    outboundLines: lines.outbound,
  };
}

// A direction's total, per unit, as one string. An empty list reads as a dash rather
// than a zero: a direction the report carries no line for is not the same as one that
// moved no bytes, and on the cost report inbound is routinely the former (nothing
// charges for ingress). The transfer trend, which runs a metered query, is where an
// honest inbound figure comes from.
export const bandwidthText = (units, formatQuantity) =>
  units.length === 0
    ? '—'
    : units.map((u) => `${formatQuantity(u.quantity)} ${u.unit}`).join(' · ');
